import { Box, FormControl, Modal, Text, TextArea } from '@bechtel/gds';
import { ToolOrderCatalog } from '@bechtel/ht-types';
import { useState } from 'react';
import { ErrorBoundary } from '~/components';
import { CatalogInfo } from '~/components/catalog-info';
import { PrimaryButtonStyled } from '~/styles';
import { ModalCloseStyled, ModalFooterStyled, ModalHeaderStyled } from '~/styles/modal-styles';
import { ItemCountStyled } from './styled';

interface ToolCatalogItemCommentDialogProps {
  visible: boolean;
  onClose: () => void;
  toolOrderCatalogItem: ToolOrderCatalog;
  onCommentUpdated: (toolOrderCatalog: ToolOrderCatalog, comments?: string) => void;
}

export const ToolCatalogItemCommentDialog: React.FC<ToolCatalogItemCommentDialogProps> = ({
  visible,
  onClose,
  toolOrderCatalogItem,
  onCommentUpdated,
}) => {
  const [comments, setComments] = useState(toolOrderCatalogItem.requesterComments || '');
  const toolCatalog = toolOrderCatalogItem.toolCatalog;
  return (
    <ErrorBoundary>
      <Modal visible={visible} style={{ width: '500px' }}>
        <ModalHeaderStyled title="Add Comments">
          <ModalCloseStyled onClick={onClose}></ModalCloseStyled>
        </ModalHeaderStyled>
        <Box p={{ sm: '500' }} flexDirection={{ sm: 'column' }}>
          <Box>
            <Box justifyContent={{ sm: 'space-between' }} mb={{ sm: '600' }} style={{ width: '100%' }}>
              <Box flexDirection={{ sm: 'column' }}>
                {toolOrderCatalogItem.toolCatalog && (
                  <CatalogInfo
                    barCode={toolCatalog && toolCatalog.bscnPartNumber ? toolCatalog.bscnPartNumber : ''}
                    description={toolCatalog && toolCatalog.name ? toolCatalog.name : ''}
                    isSerialized={['Individual', 'Equipment'].includes(toolCatalog?.inventoryType ?? '') ? true : false}
                    uomAbbreviation={toolCatalog?.uom ? toolCatalog.uom.abbreviation : ''}
                  />
                )}
                {!toolOrderCatalogItem.toolCatalog && (
                  <Box flexDirection={{ sm: 'column' }} gap={{ sm: '300' }}>
                    <Text color="blue.800" weight="600" size="450" family="openSansSemiBold">
                      Non-Catalog Item
                    </Text>
                    <Text color="grey.600" weight="500" size="200" family="openSans">
                      {toolOrderCatalogItem?.nonCatalogDescription}
                    </Text>
                  </Box>
                )}
              </Box>

              <ItemCountStyled>
                <Text color="blue.800" size="400">
                  {toolOrderCatalogItem.quantity}
                </Text>
              </ItemCountStyled>
            </Box>
          </Box>
          <FormControl label={'Write Comment'}>
            <TextArea
              rows="5"
              placeholder="Type here"
              value={comments}
              onChange={(event) => setComments(event.target.value)}
            ></TextArea>
          </FormControl>
        </Box>

        <ModalFooterStyled>
          <Box justifyContent={{ sm: 'flex-end' }}>
            <PrimaryButtonStyled
              onClick={() => {
                onCommentUpdated(toolOrderCatalogItem, comments);
                onClose();
              }}
            >
              Save Comment
            </PrimaryButtonStyled>
          </Box>
        </ModalFooterStyled>
      </Modal>
    </ErrorBoundary>
  );
};
